import Instance from '../../../../Axios';

// New Actions for the app

const GetReservasHistorico = (id) => async (dispatch) => {
  console.log(id);
  await Instance()
    .get(`/backend/reservas/historico`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_RESERVAS_HISTORICO', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetReservasHistorico;
